module.exports = __webpack_public_path__ + "static/media/history_29.e5a97c88.jpg";